import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import DropDownComponent from '../dropdown';
import DefaultAvatar from '../../assets/images/default-avatar.webp';
import { Avatar, AvatarImage, AvatarWrapper, DropdownSVGWrapper, User, UserAvatarActionWrapper, UserName } from './user-avatar-action.style';
import { ChevronRightSvg } from '../../assets/svgs';

const UserAvatarActionComponent = ({ name = 'Name here', image, userActions, icon: Icon, removeDropdown, mui }) => {
    const dropdownRef = useRef();
    const [anchorEl, setAnchorEl] = useState(null);

    const [states, setStates] = useState({
        dropdownOpen: false,
    });

    const handleDropdown = (e) => {
        if (userActions && userActions.length > 0) {
            setStates((old) => ({ ...old, dropdownOpen: !states.dropdownOpen }));
            setAnchorEl(e.currentTarget);
        }
    };

    const handleCloseDropdown = () => {
        setStates((old) => ({ ...old, dropdownOpen: false }));
        setAnchorEl(null);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target) && !mui) {
                handleCloseDropdown();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <UserAvatarActionWrapper ref={dropdownRef}>
            <User>
                <UserName>{name}</UserName>
                <AvatarWrapper onClick={handleDropdown}>
                    {
                        Icon ? (
                            <Avatar>
                                <Icon />
                            </Avatar>
                        ) : (
                            <Avatar
                                style={{ backgroundImage: `url(${DefaultAvatar})` }}
                            >
                                {
                                    image &&
                                    <AvatarImage style={{ backgroundImage: `url(${image})` }} />
                                }
                            </Avatar>
                        )
                    }

                    {
                        userActions && userActions.length > 0 && !removeDropdown &&
                        <DropdownSVGWrapper className='box-shadow' $isdropdownopen={states.dropdownOpen}>
                            <ChevronRightSvg />
                        </DropdownSVGWrapper>
                    }
                </AvatarWrapper>
            </User>

            {
                states.dropdownOpen && !removeDropdown && (
                    <DropDownComponent
                        isOpen={states.dropdownOpen}
                        close={handleCloseDropdown}
                        actions={userActions}
                        mui={mui}
                        anchorEl={anchorEl}
                    />
                )
            }
        </UserAvatarActionWrapper>
    );
};

UserAvatarActionComponent.propTypes = {
    name: PropTypes.object,
    image: PropTypes.string,
    icon: PropTypes.elementType,
    userActions: PropTypes.array,
    removeDropdown: PropTypes.bool,
    mui: PropTypes.bool,
};

export default UserAvatarActionComponent;
